






























































// TODO: перенести в общий css файл для стилей профиля
import './styles/styles.styl';

import { Spinner as LoadingSpinner } from '@/components/spinners';
import { validationMixin } from 'vuelidate';
import { Button } from '@/pages/profile/components';
import AppSvgIcon from '@/uikit/components/AppSvgIconNew';
import Infotext from '@/components/parts/infotext';
import AddEditWorkPlaceBody from '@/pages/profile/views/work/components/AddEditWorkPlaceBody.vue';
import AddEditWorkPlaceHeader from '@/pages/profile/views/work/components/AddEditWorkPlaceHeader.vue';
import { IWorkPlace } from '@/pages/profile/views/work/types';

export default {
  name: 'Work',
  mixins: [validationMixin],
  components: {
    Button,
    AppSvgIcon,
    Infotext,
    LoadingSpinner,
  },
  data() {
    return {
      dateMask: [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/],
      count: 1,
      works: [],
      isLoadReq: false,
      isServerReqError: false,
      serverErrorMessages: '',
    };
  },
  computed: {
    regions() {
      return this.$store.state.regionsDict;
    },

    profSpheres() {
      return this.$store.state.profSpheres;
    },

    organizations() {
      const organizationsItems = this.$store.state.organizators.map(
        (el: any) => {
          return {
            text: el.name,
            value: el.id,
          };
        }
      );
      /// добавялем удаленные в букинге айтемы если не нашли в оргнизациях, но есть в partner
      this.works.map((el: any) => {
        el.partner.id &&
        !organizationsItems.find((item: any) => item.value === el.partner.id)
          ? organizationsItems.unshift({
              text: el.partner.name,
              value: el.partner.id,
              isDisabled: true,
            })
          : null;
      });
      return organizationsItems;
    },
  },

  methods: {
    async removeItem(item: IWorkPlace) {
      const index = this.works.findIndex((el: IWorkPlace) => el.id === item.id);
      if (!item.is_new) {
        const { data } = await this.$axiosInstance.post('places-work/delete', {
          data: {
            id: item.id,
          },
        });
        data.success ? this.works.splice(index, 1) : null;
      } else if (item.is_new) {
        this.works.splice(index, 1);
      }
    },
    initData() {
      this.$store.state.user.profile.places_work < 1
        ? (this.works = [])
        : (this.works = this.$store.state.user.profile.places_work.map(
            (el: any) => {
              return {
                ...el,
                acceptance_date: el.acceptance_date
                  ? this.$util.dateConvertApiFormatToRusViewFormat(
                      el.acceptance_date
                    )
                  : '',
                dismissal_date: el.dismissal_date
                  ? this.$util.dateConvertApiFormatToRusViewFormat(
                      el.dismissal_date
                    )
                  : '',
                /// автоматически переключаем флаг и присваевмем значение айди если есть el.partner
                work_place:
                  el.partner.id && el.partner.name
                    ? el.partner.id
                    : el.work_place,
                is_inner_organizations: el.partner.id && el.partner.name,
              };
            }
          ));
    },

    async sendData(works: Array<IWorkPlace>) {
      /** в общем тут всё оч не тривиально
       * логика следующая,
       * 1) если есть флаг is_inner_organizations true (значит это селектор)
       * то отправляем в partner_id из work_place значение, это будет айдишник (partner - лишнее поле, ни на чё не влияеьт)
       * затем в сам work_place перезаписываем значение name из найденного по айди айтема опшенса селектора
       * 2) если флаг is_inner_organizations false (значит это текстовое поле)
       * то мы передаём partner_id: "" что бы стереть в бд связь, т.к. теперь это не организация платформы, а просто какой-то текст
       * ну и в work_place этот самый какой-то текст.
       * */
      this.isLoadReq = true;
      this.isServerReqError = false;
      const toDate = (value: any, a: any, b: any) =>
        (value || '').split(a).reverse().join(b);
      const toUtc = (value: any) => toDate(value, '.', '-');
      try {
        await this.$store.dispatch('user/updateProfile', {
          places_work: works.map((el: any) => {
            return {
              ...el,
              id: el.is_new ? null : el.id,
              work_place: el.is_inner_organizations
                ? this.organizations.find(
                    (item: any) => item.value === el.work_place
                  ).text
                : el.work_place,
              partner_id: el.is_inner_organizations ? el.work_place : '',
              acceptance_date: el.acceptance_date
                ? toUtc(el.acceptance_date)
                : '',
              dismissal_date: el.dismissal_date ? toUtc(el.dismissal_date) : '',
            };
          }),
        });
        this.initData();
      } catch (e) {
        this.isServerReqError = true;
        throw e;
      }
      this.isLoadReq = false;
    },

    showModal(newItem: IWorkPlace | any = {}) {
      const { regions, organizations, profSpheres } = this;

      this.$ui.$modal.show('AddEditWorkPlace', {
        settings: {
          size: {
            width: '500px',
            maxWidth: '500px',
          },
        },
        bind: this, // контекст
        slots: {
          header: {
            component: AddEditWorkPlaceHeader,
            propsData: {
              title: newItem.id
                ? 'Редактирование места работы'
                : 'Добавление места работы',
            },
          },
          body: {
            component: AddEditWorkPlaceBody,
            propsData: {
              saveMethod: this.sendData,
              works: this.works,
              regions: regions.map((el: Record<string, number>) => ({
                text: el.name,
                value: el.id,
              })),
              partners: organizations,
              profSpheres: profSpheres.map((el: Record<string, number>) => ({
                text: el.name,
                value: el.id,
              })),
            },
          },
        },
      });
    },
  },

  created() {
    this.initData();
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/work/Work.vue